var map = {
	"./areas-main/areas-main.scss": "./src/block/general/areas-main/areas-main.scss",
	"./cards-with-icons/cards-with-icons.scss": "./src/block/general/cards-with-icons/cards-with-icons.scss",
	"./feedback-form/feedback-form.js": "./src/block/general/feedback-form/feedback-form.js",
	"./feedback-form/feedback-form.scss": "./src/block/general/feedback-form/feedback-form.scss",
	"./form/form.js": "./src/block/general/form/form.js",
	"./form/form.scss": "./src/block/general/form/form.scss",
	"./lang-switch/lang-switch.js": "./src/block/general/lang-switch/lang-switch.js",
	"./offers-slider/offers-slider.js": "./src/block/general/offers-slider/offers-slider.js",
	"./offers-slider/offers-slider.scss": "./src/block/general/offers-slider/offers-slider.scss",
	"./page-banner/page-banner.scss": "./src/block/general/page-banner/page-banner.scss",
	"./page-menu-nav/page-menu-nav.js": "./src/block/general/page-menu-nav/page-menu-nav.js",
	"./page-menu-nav/page-menu-nav.scss": "./src/block/general/page-menu-nav/page-menu-nav.scss",
	"./page-menu/page-menu.js": "./src/block/general/page-menu/page-menu.js",
	"./page-menu/page-menu.scss": "./src/block/general/page-menu/page-menu.scss",
	"./popup-form/popup-form.js": "./src/block/general/popup-form/popup-form.js",
	"./popup-form/popup-form.scss": "./src/block/general/popup-form/popup-form.scss",
	"./stages/stages.scss": "./src/block/general/stages/stages.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/block/general sync recursive ^\\.\\/[^/]+\\/[^/.]+\\.(js%7Ccss%7Cscss%7Csass%7Cless)$";